import React, { useContext } from "react";
import ContextApp from "../../core/contexts/context.app";
import ApiUserWallet from "../../core/api/api.userWallet";
import ServiceStorage from "../../core/services/service.storage";
import _ from "lodash";
import { Helmet } from "react-helmet-async";

const BeforePageRender = (props) => {
  const ctx = useContext(ContextApp);
  // ReactGA.pageview(window.location.pathname + window.location.search);
  // ReactGA4.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  // console.log("BeforePageRender props.pageTitle",props.pageTitle);

  //console.log("BeforePageRender ");
  async function getWallet() {
    let lastUpdate = ctx.lastUpdate;
    let uInfo = ServiceStorage.getUserInfo();
    if (
      ctx.isAuth &&
      !_.isEmpty(lastUpdate) &&
      _.has(lastUpdate, "walletBalance")
    ) {
      let now = new Date(_.now());
      let lastUpdateUserInfo = new Date(lastUpdate.walletBalance);

      //تفاوت زمان آخرین آپدیت یوزراینفو با زمان فعلی
      let lastUpdateDifferentFromNow =
        (now.getTime() - lastUpdateUserInfo.getTime()) / 60000;
      //---------------------------------------------

      if (_.isEmpty(lastUpdate) || lastUpdateDifferentFromNow > 3) {
        //به روزرسانی فیلد زمان اخرین اپدیت یوزراینفو
        ctx.setLastUpdate({ walletBalance: _.now() });
        //------------------ زمان اخرین اپدیت یوزراینفو ----------------------------

        let result = await ApiUserWallet.getWalletBalance();
        if (result != null && result.isAuth != null && !result.isAuth) {
          // ctx.setIsAuth(false);
        } else if (result.data != null && uInfo != null) {
          uInfo.walletRiallBalance = result.data.riallBalance;
          uInfo.walletAvailableRiallBalance =
            result.data.useAvailableRiallBalance;
          ServiceStorage.setUserInfo(uInfo);
          ctx.setUserInfo(uInfo);
        }
      }
    } else if (ctx.isAuth) {
      //به روزرسانی فیلد زمان اخرین اپدیت یوزراینفو
      ctx.setLastUpdate({ walletBalance: _.now() });
      //------------------ زمان اخرین اپدیت یوزراینفو ----------------------------
      let result = await ApiUserWallet.getWalletBalance();
      if (result != null && result.isAuth != null && !result.isAuth) {
        // ctx.setIsAuth(false);
      } else if (result.data != null && uInfo != null) {
        ServiceStorage.setUserInfo(uInfo);
        ctx.setUserInfo(uInfo);
      }
    }
    //تکمیل اطلاعات کاربر
  }
  getWallet();

  // حذف متا های اضافه از هدر
  props.metaDel &&
    props.metaDel.length > 0 &&
    props.metaDel.forEach((element) => {
      const elem = document.head.querySelectorAll(element)[0];
      elem && elem.remove();
    });

  //console.log("desc", props.pageDescription);
  return (
    <>
      <div className="wrapper">
        <Helmet>
          {props.pageTitle && <title>{props.pageTitle}</title>}
          {props.pageTitle && (
            <meta property="og:title" content={props.pageTitle} />
          )}
          {props.pageDescription && (
            <meta name="description" content={props.pageDescription} />
          )}
          {props.pageDescription && (
            <meta property="og:description" content={props.pageDescription} />
          )}
          {props.canonical && <link rel="canonical" href={props.canonical} />}
          {props.pageUrl && <meta property="og:url" content={props.pageUrl} />}
        </Helmet>
      </div>
    </>
  );
};
export default BeforePageRender;
